export default __webpack_public_path__ + "static/media/logo.2269fe55.png";